import React from "react";
import Privacy from "@components/antiviruschoice/privacy";
import { GetServerSideProps } from "next";
import AntiVirusChoiceWrapper from "@components/layouts/antiVirusChoiceWrapper";
import { getPageProps } from "@services/initial-calls";

const PrivacyPage = (): JSX.Element => {
    return (
        <AntiVirusChoiceWrapper>
            <Privacy />
        </AntiVirusChoiceWrapper>
    );
};
export default PrivacyPage;

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Privacy Policy",
    });
};
